<template>
    <!-- Shared header row for every procedure form: عنوان الطلب / السنة / الفترة.
         Add fields here and they appear on all procedures at once. -->
    <v-row dense class="rhf">
        <v-col cols="12" md="6">
            <label class="fld">{{ $t('AddRequestTitle') }} <span class="req">*</span></label>
            <v-text-field :value="value.requestTitle"
                          outlined dense hide-details="auto"
                          :rules="titleRule"
                          counter="200" maxlength="200"
                          :placeholder="$t('AddRequestTitle')"
                          @input="update('requestTitle', $event)" />
        </v-col>

        <v-col cols="6" md="3">
            <label class="fld">{{ $t('RequestYear') }}</label>
            <v-select :value="value.year"
                      :items="years"
                      outlined dense hide-details="auto" clearable
                      @input="update('year', $event)" />
        </v-col>

        <v-col cols="6" md="3">
            <label class="fld">{{ $t('Period') }}</label>
            <v-select :value="value.period"
                      :items="periods"
                      item-text="text" item-value="value"
                      outlined dense hide-details="auto" clearable
                      @input="update('period', $event)" />
        </v-col>
    </v-row>
</template>

<script>
    // the six values the dropdown offers, stored as stable codes so the
    // Arabic wording can change without touching saved requests
    export const PERIOD_CODES = ['Q1', 'Q2', 'Q3', 'Q4', 'H1', 'H2']

    export function emptyRequestHeader() {
        return { requestTitle: '', year: new Date().getFullYear(), period: '' }
    }

    export default {
        props: {
            value: {
                type: Object,
                required: true
            },
            // how many years back/forward the السنة dropdown offers
            yearsBack: {
                type: Number,
                default: 3
            },
            yearsForward: {
                type: Number,
                default: 3
            }
        },

        computed: {
            years() {
                const current = new Date().getFullYear()
                const list = []
                for (let y = current + this.yearsForward; y >= current - this.yearsBack; y--) {
                    list.push(y)
                }
                return list
            },

            periods() {
                return [
                    { value: 'Q1', text: this.$t('PeriodQ1') },
                    { value: 'Q2', text: this.$t('PeriodQ2') },
                    { value: 'Q3', text: this.$t('PeriodQ3') },
                    { value: 'Q4', text: this.$t('PeriodQ4') },
                    { value: 'H1', text: this.$t('PeriodH1') },
                    { value: 'H2', text: this.$t('PeriodH2') },
                ]
            },

            titleRule() {
                return [v => (!!v && String(v).trim().length > 0) || this.$t('RequiredField')]
            }
        },

        methods: {
            update(key, val) {
                this.$emit('input', { ...this.value, [key]: val })
            }
        }
    }
</script>

<style scoped>
    .rhf { margin-bottom: 4px; }
    .fld { display: block; font-weight: 600; font-size: 13px; color: #37474f; margin-bottom: 6px; }
    .req { color: #e53935; }
</style>
